import { SortOrder } from "consts/request-query";
import { convertToDateTime } from "util/transformers";
import type {
    OnboardingApplicationLogsPaginator,
    OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges
} from "../types";

export const sortByUpdatedDateTime = (sortOrder = SortOrder.Asc) => ({ data, ...paginator }: OnboardingApplicationLogsPaginator<
    Record<
        string,
        OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges[]
    >
>) => ({
    ...paginator,
    data: Object.entries(data)
        .reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value.sort((a, b) => ({
                [SortOrder.Asc]: () => convertToDateTime(a.updatedDateTime)!.valueOf() - convertToDateTime(b.updatedDateTime)!.valueOf(),
                [SortOrder.Desc]: () => convertToDateTime(b.updatedDateTime)!.valueOf() - convertToDateTime(a.updatedDateTime)!.valueOf()
            }[sortOrder]()))
        }), {})
});
